import { useEffect, useRef, useState } from 'react';
import { animate, useInView } from 'framer-motion';
import { useLanguage } from '@/context/LanguageContext';
import { Stagger, StaggerItem } from '@/components/Reveal';

function CountUp({ text }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const match = String(text).match(/[\d.]+/);
  const [display, setDisplay] = useState(match ? '0' + text.slice(match.index + match[0].length) : text);

  useEffect(() => {
    if (!match || !inView) return;
    const target = parseFloat(match[0]);
    const dec = (match[0].split('.')[1] || '').length;
    const controls = animate(0, target, {
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => {
        const n = v.toFixed(dec);
        const grouped = dec ? n : n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        setDisplay(grouped + text.slice(match.index + match[0].length));
      },
    });
    return () => controls.stop();
  }, [inView]);

  return <span ref={ref} dir="ltr">{display}</span>;
}

export default function StatsBand() {
  const { t } = useLanguage();
  const stats = t('stats');
  return (
    <section className="border-y border-brand-line bg-white py-14" data-testid="stats-band">
      <Stagger className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-5 lg:grid-cols-4 lg:px-8" gap={0.1}>
        {stats.map((s) => (
          <StaggerItem key={s.l} className="text-center lg:text-start">
            <p className="font-display text-3xl font-extrabold tracking-tight text-brand-blue sm:text-4xl" data-testid={`stat-${s.l}`}>
              <CountUp text={s.v} />
            </p>
            <p className="mt-2 text-sm font-semibold text-brand-steel">{s.l}</p>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
